module.exports = __webpack_public_path__ + "img/angle up.e73b2779.svg";